import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getSearchedUser } from "./../api/index";
import { editUser } from "./../redux/actions/user";
import { useHistory } from "react-router-dom";
import Post from "./posts/post/Post";
import PostForm from "./PostForm";
import FileBase64 from "react-file-base64";
import { Grid, Container, Paper, Typography, Avatar, Button, TextField, Grow, CircularProgress } from "@material-ui/core";
import { delAccount } from "./../redux/actions/user";

const url = "https://picsum.photos/500";

const User = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const id = window.location.pathname;
    const currentUser = JSON.parse(localStorage.getItem("profile"));
    const [user, setUser] = useState({});
    const [oldPass, setOldPass] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const editState = useSelector(state => state.user);
    const userPosts = useSelector(state => state.posts.filter(post => post.creator === user._id));

    useEffect(() => getSearchedUser(id).then(({ data }) => setUser(data)), []);

    const handleEditMode = () => {
        if (editMode) dispatch(editUser(user._id, { user, oldPass }, history));
        else setEditMode(true);
    }

    const handleChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

    if (!user._id) return (
        <div style={{ textAlign: "center" }}>
            <CircularProgress color="inherit" />
        </div>
    );

    return (
        <Grow in>
            <Container maxWidth="md">
                <Grid container spacing={2} alignItems="flex-start">
                    <Grid item xs={12} justify="space-between">

                        <div className="cover" style={{ backgroundImage: `url(${user?.coverPic ? user?.coverPic : url})` }}>

                            <Avatar style={{
                                width: "100px", height: "100px", margin: "0 auto", position: "absolute",
                                bottom: "0", left: "40%", border: "3px solid white"
                            }} src={`${user?.profilePic}`}
                            >
                                <h1>{user?.name?.charAt(0)}</h1>
                            </Avatar>

                            {editMode && (
                                <span style={{ position: "absolute", bottom: "0", left: "0" }}>
                                    <FileBase64 type="file" multiple={false}
                                        onDone={({ base64 }) => setUser({ ...user, coverPic: base64 })} />
                                </span>
                            )}

                        </div>

                        <Paper elevation={3} style={{ padding: "5px 20px", display: "flex", opacity: "0.97" }}>
                            <span style={{ flex: 1 }}>
                                <Typography variant="h4">{user.name}</Typography>
                            </span>

                            {user._id === currentUser?.user?._id && (
                                <Button variant="contained" color="primary" onClick={handleEditMode}>
                                    {editMode ? "Save changes" : "Edit Profile"}
                                </Button>
                            )}
                        </Paper>

                    </Grid>

                    {editMode && (
                        <Grid item xs={12} sm={4}>
                            <Paper elevation={3} style={{ padding: "5px" }}>
                                <Typography variant="h6">Edit Profile</Typography>

                                <hr></hr>

                                <TextField margin="normal" name="name" label="Full Name" variant="outlined" value={user.name}
                                    fullWidth onChange={handleChange} />

                                <TextField margin="normal" name="password" label="New Password" variant="outlined" type="password"
                                    fullWidth onChange={handleChange} />
                                <small style={{ color: "red" }}>If this is kept empty , your password won't change !</small>

                                <FileBase64 type="file" multiple={false} onDone={({ base64 }) => setUser({ ...user, profilePic: base64 })} />

                                <TextField margin="normal" name="currentPassword" label="Current Password" variant="outlined" type="password"
                                    fullWidth onChange={e => setOldPass(e.target.value)} />

                                <small style={{ color: "red", display: "block" }}>{editState.error}</small>

                                <small style={{ margin: "5px", color: "black", fontWeight: "bold", display: "block" }}>
                                    After submitting changes you will be logged out!
                                </small>

                                <div style={{ textAlign: "center" }}>
                                    {editState.loading && (
                                        <CircularProgress />
                                    )}
                                </div>

                                <Button fullWidth color="secondary" size="small" variant="contained"
                                    onClick={() => dispatch(delAccount(user._id, history, oldPass))}>
                                    Delete Account
                                </Button>
                            </Paper>
                        </Grid>
                    )}

                    {currentId && (
                        <Grid item xs={12} sm={4}>
                            <PostForm currentId={currentId} setCurrentId={setCurrentId} />
                        </Grid>
                    )}

                    {userPosts.length === 0 ?
                        (
                            <Paper elevation={3} style={{ padding: "10px" }}>
                                <Typography variant="h6" align="center">
                                    This user does not have any posts yet !
                                </Typography>
                            </Paper>
                        ) : (
                            userPosts.reverse().map(p => {
                                return (
                                    <Grid key={p._id} item xs={12} sm={6} md={4}>
                                        <Post post={p} setCurrentId={setCurrentId} />
                                        <br></br>
                                    </Grid>
                                );
                            })
                        )
                    }
                </Grid>
            </Container>
        </Grow>
    )
}

export default User;